import clsx from 'clsx'
import { ProgressBar } from '@pepper/ui'
import { ColumnsType } from 'antd/lib/table'

import {
  TopOrganicKeywordsDistribution,
  TopOrganicKeywordsList,
} from '../types'

import s from './TopOrganicKeywords.module.css'

export const getColumns = <
  RecordType extends TopOrganicKeywordsDistribution
>(): ColumnsType<RecordType> | undefined => {
  return [
    {
      title: <div className={s.title}>Keyword Rank</div>,
      dataIndex: 'traffic_range',
      key: 'traffic_range',
      width: '30%',
      render: (_, value) => {
        return <div className={s.row}> {value.rank_range.Name}</div>
      },
    },
    {
      title: <div className={s.title}>Number of Keywords</div>,
      dataIndex: 'keywords',
      key: 'keywords',
      width: '25%',
      render: (_, value) => {
        return (
          <div className={clsx(s.progressWrapper, s.row, s.centerAlign)}>
            <div className={clsx(s.textWrapper)}>
              <div className={clsx(s.progressValue, s.rightAlign)}>
                {value.total_keyword.Value.toLocaleString()}
              </div>
              <div className={clsx(s.percent, s.rightAlign)}>
                {value.total_keyword.Percentage.toFixed(2)}%
              </div>
            </div>
            <ProgressBar
              size="small"
              className={s.progressBar}
              percent={value.total_keyword.Percentage}
              strokeColor="rgba(163, 153, 255, 1)"
              trailColor="rgba(233, 236, 239, 1)"
            />
          </div>
        )
      },
    },
    {
      title: (
        <div className={clsx(s.title, s.leftAlign)}>
          Cum. Organic Search Traffic
        </div>
      ),
      dataIndex: 'name',
      key: 'name',
      width: '20%',
      render: (_, value) => {
        return (
          <div className={clsx(s.progressWrapper, s.row)}>
            <div className={s.textWrapper}>
              <div className={clsx(s.progressValue, s.rightAlign)}>
                {value.traffic.Value.toLocaleString()}
              </div>
              <div className={clsx(s.percent, s.rightAlign)}>
                {value.traffic.Percentage.toFixed(2)}%
              </div>
            </div>
            <ProgressBar
              size="small"
              className={s.progressBar}
              percent={value.traffic.Percentage}
              strokeColor="rgba(163, 153, 255, 1)"
              trailColor="rgba(233, 236, 239, 1)"
            />
          </div>
        )
      },
    },
  ]
}

export const getListColumns = <
  RecordType extends TopOrganicKeywordsList
>(): ColumnsType<RecordType> => {
  return [
    {
      title: <div className={s.title}>Keyword</div>,
      dataIndex: 'keyword_traffic',
      key: 'keyword_traffic',
      width: '30%',
      render: (_, record) => {
        return (
          <div className={s.row}>
            {record.keyword_traffic.breakdown?.[0].query}
          </div>
        )
      },
    },
    {
      title: <div className={s.title}>Organic Search Traffic</div>,
      dataIndex: 'search_traffic',
      key: 'search_traffic',
      width: '25%',
      render: (_, value) => {
        return (
          <div className={clsx(s.progressWrapper, s.row, s.leftAlign)}>
            <div className={s.textWrapper}>
              <div className={clsx(s.progressValue, s.rightAlign)}>
                {value.keyword_traffic.value}
              </div>
              <span className={clsx(s.percent, s.rightAlign)}>
                {value.keyword_traffic.percentage.toFixed(2)}%
              </span>
            </div>
            <ProgressBar
              size="small"
              className={s.progressBar}
              percent={value.keyword_traffic?.percentage}
              strokeColor="rgba(163, 153, 255, 1)"
              trailColor="rgba(233, 236, 239, 1)"
            />
          </div>
        )
      },
    },
    {
      title: <div className={clsx(s.title, s.leftAlign)}>Search Volume</div>,
      dataIndex: 'search_volume',
      key: 'search_volume',
      width: '15%',
      render: (_, value) => {
        return (
          <div className={clsx(s.row, s.leftAlign)}>
            {value.search_volume.value.toLocaleString()}
          </div>
        )
      },
    },
    {
      title: <div className={clsx(s.title, s.leftAlign)}>Avg. Position</div>,
      dataIndex: 'position',
      key: 'position',
      width: '10%',
      render: (_, value) => {
        return (
          <div className={clsx(s.row, s.rightAlign)}>
            {value.position.value.toFixed(2)}
          </div>
        )
      },
    },
    {
      title: <div className={s.title}>Money Saved</div>,
      dataIndex: 'cost_saved',
      key: 'cost_saved',
      width: '10%',
      render: (_, value) => {
        return (
          <div className={clsx(s.row, s.rightAlign)}>
            {`$${value.cost_saved.value.toFixed(2)}`}
          </div>
        )
      },
    },
  ]
}
